import { RouteObject } from "react-router-dom";

import { AuthorizedRoute } from "src/authentication/AuthorizedRoute.tsx";
import { Scope, ScopeResource } from "src/authentication/PermissionsProvider";
import ErrorBoundary from "src/components/Errors/ErrorBoundary.tsx";
import { useT } from "src/internationalization";
import { ScenarioDetailsPage } from "src/pages/ScenarioDetails/ScenarioDetailsPage.tsx";
import { ScenarioVersionDetailsPage } from "src/pages/ScenarioDetails/ScenarioVersionDetailsPage.tsx";
import ScenariosPage from "src/pages/Scenarios/ScenariosPage.tsx";
import ScenarioTab from "src/pages/Scenarios/ScenarioTab.tsx";

export const useScenarioRoutes = (): RouteObject[] => {
  const t = useT();

  return [
    {
      path: "scenarios",
      element: (
        <AuthorizedRoute
          requiredPermissions={[{ resource: ScopeResource.SCENARIO, scopes: [Scope.VIEW] }]}
          pageTitle={t("scenarios.title")}
        >
          <ScenariosPage />
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
      children: [
        {
          path: ":code",
          Component: ScenarioTab,
        },
      ],
    },
    {
      path: "scenario/:caseTypeCode/:id/:code",
      element: (
        <AuthorizedRoute
          requiredPermissions={[{ resource: ScopeResource.SCENARIO, scopes: [Scope.VIEW] }]}
          pageTitle={t("scenario.title")}
        >
          <ScenarioDetailsPage />
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
    },
    {
      path: "scenario/:caseTypeCode/:id/:code/:versionId",
      element: (
        <AuthorizedRoute
          requiredPermissions={[{ resource: ScopeResource.SCENARIO, scopes: [Scope.VIEW] }]}
          pageTitle={t("scenario.title")}
        >
          <ScenarioVersionDetailsPage />
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
    },
  ];
};
